import Helper from '@ember/component/helper';

import { addObserver, removeObserver } from '@ember/object/observers';
import { once } from '@ember/runloop';

export default class EmberArrayHelper extends Helper {
  onChange() {
    once(this, 'recompute');
  }
  compute([array]) {
    if (this.array) {
      removeObserver(this.array, '[]', this, 'onChange');
    }
    if (!array?.['[]']) {
      return;
    }
    this.array = array;
    // eslint-disable-next-line ember/no-observers
    addObserver(array, '[]', this, 'onChange');
    return array;
  }
}
